import React from 'react';
import { CircleLogo } from '../assests';
import { Link } from 'react-router-dom';
import './Header.css'; // Assuming you have a CSS file for styling

const LandingPage = () => {
  return (
    <div>
      <header className="header-container">
        <div className="logo-section">
          <img src={CircleLogo} alt="Logo" className="logo-image" />
          <p className="company-name">
            ACE Engineerings &<br />Chemicals Pvt Ltd
          </p>
        </div>
        <nav className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/product">Products</Link>
          <Link to="/technologies">Technologies</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
        </nav>
      </header>
    </div>
  );
};

export default LandingPage;
